import React from "react";
import Slider from "react-slick";

// ClientsSlider Component
const ClientsSlider = () => {
  const clients = [
    "/img/client1.png",
    "/img/client2.png",
    "/img/client3.png",
    "/img/client4.png",
    "/img/client5.png",
    "/img/client1.png", // Repeated to loop in carousel
    "/img/client2.png", // Repeated to loop in carousel
    "/img/client3.png", // Repeated to loop in carousel
    "/img/client4.png", // Repeated to loop in carousel
  ];

  // React Slick carousel settings
  const settings = {
    infinite: true, // Loop the carousel infinitely
    speed: 500, // Animation speed
    slidesToShow: 4, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3, // Show 3 slides on medium screens
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2, // Show 2 slides on small screens
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1, // Show 1 slide on very small screens
        },
      },
    ],
  };

  return (
    <div className="clients overlay">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-12">
            {/* React Slick Slider */}
            <Slider {...settings} className="owl-carousel clients-slider">
              {clients.map((clientImage, index) => (
                <div key={index} className="single-clients">
                  <img src={clientImage} alt={`client-${index + 1}`} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientsSlider;
